module.exports = __webpack_public_path__ + "images/stickers/pete-love.486f2fa23b8d76ae8190.png";